import { ICommonFieldProps } from "../../../../interfaces";
const AddressEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;
  return (
    <input
      className="input-field"
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
};

export default AddressEditCell;
